import { randomString } from "./string"
import { isAnonymisedEmail, isFakeEmail } from "../../utils/email"

export { isAnonymisedEmail, isFakeEmail }

export function anonymiseEmail(email: string, tag?: string) {
  if (tag) tag += "___"
  const rand = Math.random().toString(36).substring(7)
  return `anon___${tag}${rand}___${email}`
}

export function restoreEmail(anonymisedEmail: string): string {
  if (anonymisedEmail.includes("+has-left")) {
    return anonymisedEmail.replace("+has-left", "")
  }

  if (isAnonymisedEmail(anonymisedEmail)) {
    return anonymisedEmail.split("___").slice(-1)[0]
  }
  console.warn(
    `Tried to restore email from anonymised email, but the email is not anonymised: ${anonymisedEmail}`,
  )
  return anonymisedEmail
}

export function getRandomEmail(companyId: string) {
  return `${randomString(10)}-${companyId}@clevergoose.tech`
}

export function getGeneratedEmail(payrollNumber: string, companyId: string) {
  return `${payrollNumber}-${companyId}@clevergoose.tech`
}
export function isGeneratedEmail(email: string, companyId: string) {
  return email.includes(`-${companyId}@clevergoose.tech`)
}
